import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLocation } from 'react-router-dom';
import { motion as motionTokens } from '../../styles/design-tokens';
import { useReducedMotion } from '../../hooks/useReducedMotion';

/**
 * PageTransition Component
 * Wraps page content with consistent entrance/exit animations
 * Respects user's motion preferences
 * 
 * @param {React.ReactNode} children - Page content
 * @param {string} variant - Animation variant: 'page' | 'fadeIn' | 'slideUp'
 */
const PageTransition = ({ children, variant = 'page' }) => {
  const location = useLocation();
  const prefersReducedMotion = useReducedMotion();
  
  // Get animation variants based on motion preference
  const variants = prefersReducedMotion 
    ? motionTokens?.reducedMotion?.variants?.[variant] 
    : motionTokens?.variants?.[variant];

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={location?.pathname}
        initial="initial"
        animate="animate"
        exit="exit"
        variants={variants}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
};

export default PageTransition;